import { gql } from './gql-func';
import * as Fragments from './fragments';

export const GraphQueries = {
  orgs: gql`
    query {
      list: orgs {
        id
        name
        icon
        create_date
        description
        role
      }
    }
  `,
  org: gql`
    query ($org: ID, $name: String) {
      result: org(org: $org, name: $name) {
        id
        name
        icon
        plan
        create_date
        description
        role
        is_template
      }
    }
  `,
  agents: gql`
    ${Fragments.originKeyFields}
    ${Fragments.agentSummaryFields}
    query ($search: String, $searchType: String) {
      list: agents(search: $search, searchType: $searchType) {
        ...agentSummaryFields
      }
    }
  `,
  serviceAgents: gql`
    ${Fragments.originKeyFields}
    ${Fragments.agentSummaryFields}
    query ($search: String, $searchType: String) {
      list: service_agents(search: $search, searchType: $searchType) {
        ...agentSummaryFields
      }
    }
  `,
  agent: gql`
    ${Fragments.originKeyFields}
    ${Fragments.agentSummaryFields}
    query ($key: DHLKeyInput!) {
      result: agent(key: $key) {
        imported_agents {
          origin_key {
            ...originKeyFields
          }
          mode
          lang
          name
          org_name
          description
        }
        ...agentSummaryFields
        icon_url
        description
        privacy
        pr_approval_required
        backend_provider_type
        template {
          ...originKeyFields
        }
        deploy_mode
        region
        permission
        knowledge_model
        knowledge_url
        knowledge_key
        read_me
      }
    }
  `,
  masterAgent: gql`
    ${Fragments.originKeyFields}
    ${Fragments.agentSummaryFields}
    query ($key: AgentNameKeyInput!) {
      result: masterAgent(key: $key) {
        ...agentSummaryFields
        icon_url
        description
        privacy
        pr_approval_required
        backend_provider_type
        template {
          ...originKeyFields
        }
        deploy_mode
        region
        permission
      }
    }
  `,
  agentAccesses: gql`
    query ($key: DHLKeyInput!) {
      agent(key: $key) {
        accesses {
          person {
            user_id
            nickname
          }
          type
          permission
        }
      }
    }
  `,
  availableParameters: gql`
    ${Fragments.attributeSummaryFields}
    ${Fragments.entitySummaryFields}
    ${Fragments.intentFields}
    ${Fragments.compositeFields}
    ${Fragments.dataQuerySummaryFields}
    ${Fragments.originKeyFields}
    query ($agentKey: DHLKeyInput!, $missionInput: SearchMissionInput) {
      agent(key: $agentKey, missionInput: $missionInput) {
        available_intents {
          ...intentFields
          origin_key {
            ...originKeyFields
          }
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_entities {
          ...entitySummaryFields
          origin_key {
            ...originKeyFields
          }
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_composites {
          ...compositeFields
          origin_key {
            ...originKeyFields
          }
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_services {
          id
          name
          source
          origin_key {
            ...originKeyFields
          }
          struct_key {
            ...originKeyFields
          }
          inherited_frames {
            frame {
              id
              name
              type
            }
          }
          is_interface
          external_qualification
          qualification
          attributes {
            ...attributeSummaryFields
          }
          data_queries {
            ...dataQuerySummaryFields
          }
          provider_type
        }
      }
    }
  `,
  intents: gql`
    ${Fragments.originKeyFields}
    ${Fragments.intentSummaryFields}
    query ($agentKey: DHLKeyInput!, $search: String) {
      agent(key: $agentKey) {
        intents(search: $search) {
          ...intentSummaryFields
        }
      }
    }
  `,
  pagingList: gql`
    ${Fragments.originKeyFields}
    ${Fragments.intentSummaryFields}
    ${Fragments.compositeSummaryFields}
    ${Fragments.entitySummaryFields}
    ${Fragments.serviceSummaryFields}
    query ($conf: PaginationConfig!) {
      pagination(conf: $conf) {
        page
        total_size
        page_size
        list {
          __typename
          ... on IntentInfo {
            ...intentSummaryFields
          }
          ... on CompositeInfo {
            ...compositeSummaryFields
          }
          ... on EntityInfo {
            ...entitySummaryFields
          }
          ... on ServiceInfo {
            ...serviceSummaryFields
          }
        }
      }
    }
  `,
  intent: gql`
    ${Fragments.originKeyFields}
    ${Fragments.trainingPhraseFields}
    ${Fragments.valueSuggestionFields}
    ${Fragments.confirmationFields}
    ${Fragments.attributeFields}
    ${Fragments.dataQueryFields}
    ${Fragments.variableFields}
    ${Fragments.serviceSlotFields}
    ${Fragments.genericTypeFields}
    ${Fragments.externalTypeFields}
    ${Fragments.attributeAssociationFields}
    ${Fragments.actionFields}
    ${Fragments.channelDataFields}
    ${Fragments.triggerConditionFields}
    ${Fragments.promptFields}
    ${Fragments.valueCheckFields}
    ${Fragments.stateUpdateFields}
    ${Fragments.frameMappingFields}
    ${Fragments.dialogActFields}
    ${Fragments.postFillActionFields}
    ${Fragments.augmentFields}
    query ($key: DHLKeyInput!) {
      result: intent(key: $key) {
        id
        name
        comment
        source
        origin_key {
          ...originKeyFields
        }
        struct_key {
          ...originKeyFields
        }
        dialog_act
        frame_expressions {
          ...trainingPhraseFields
        }
        negative_expressions {
          ...trainingPhraseFields
        }
        entailment_expressions {
          ...trainingPhraseFields
        }
        abort_expressions {
          ...trainingPhraseFields
        }
        abort_negative_expressions {
          ...trainingPhraseFields
        }
        abort_entailment_expressions {
          ...trainingPhraseFields
        }
        attributes {
          ...attributeFields
        }
        nested_slot_customizations {
          ...attributeFields
        }
        data_queries {
          ...dataQueryFields
        }
        services {
          ...serviceSlotFields
          state
          inherited_from_composite_id
          inherited_from_composite_name
          is_overwrite
        }
        value_suggestions {
          ...valueSuggestionFields
        }
        inherited_frames {
          frame {
            id
            name
            type
          }
        }
        generic_types {
          ...genericTypeFields
        }
        external_types {
          ...externalTypeFields
        }
        associations {
          ...attributeAssociationFields
        }
        branching
        responses {
          id
          name
          origin_key {
            ...originKeyFields
          }
          struct_key {
            ...originKeyFields
          }
          owner_id
          is_else_branch
          condition_type
          trigger_conditions {
            ...triggerConditionFields
          }
          code_condition
          code_comment
          channels {
            ...channelDataFields
          }
          early_termination
        }
        soft
        soft_response {
          ...augmentFields
        }
        enable_fallback
        fallback_info {
          ...augmentFields
        }
        confirmations {
          ...confirmationFields
        }
        value_checks {
          ...valueCheckFields
        }
        state_updates {
          ...stateUpdateFields
        }
        mappings {
          ...frameMappingFields
        }
        dialog_acts {
          ...dialogActFields
        }
        post_fill_actions {
          ...postFillActionFields
        }
        cron_data {
          data_query_id
          schedule
        }
        external_qualification
        qualification
        triggered_by_du
        triggers
        description
        return_info {
          type {
            ...variableFields
          }
          multi_valued
          value
          value_comment
          async
          actions {
            ...actionFields
          }
        }
        boolean_gate_prompts
        boolean_gate_expressions_yes {
          ...trainingPhraseFields
        }
        boolean_gate_expressions_no {
          ...trainingPhraseFields
        }
      }
    }
  `,
  intentAvailableParameters: gql`
    ${Fragments.attributeSummaryFields}
    ${Fragments.entitySummaryFields}
    ${Fragments.intentFields}
    ${Fragments.compositeFields}
    ${Fragments.dataQuerySummaryFields}
    ${Fragments.originKeyFields}
    query ($intentKey: DHLKeyInput!, $agentKey: DHLKeyInput!) {
      intent(key: $intentKey) {
        dialog_act
        attributes {
          ...attributeSummaryFields
        }
        data_queries {
          ...dataQuerySummaryFields
        }
      }
      agent(key: $agentKey) {
        available_intents {
          ...intentFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_entities {
          ...entitySummaryFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_composites {
          ...compositeFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_services {
          id
          name
          source
          origin_key {
            ...originKeyFields
          }
          struct_key {
            ...originKeyFields
          }
          inherited_frames {
            frame {
              id
              name
              type
            }
          }
          is_interface
          external_qualification
          qualification
          attributes {
            ...attributeSummaryFields
          }
          data_queries {
            ...dataQuerySummaryFields
          }
          provider_type
        }
      }
    }
  `,
  availableIntents: gql`
    ${Fragments.originKeyFields}
    ${Fragments.intentSummaryFields}
    query ($key: DHLKeyInput!) {
      agent(key: $key) {
        available_intents {
          ...intentSummaryFields
        }
      }
    }
  `,
  composites: gql`
    ${Fragments.originKeyFields}
    ${Fragments.compositeSummaryFields}
    query ($agentKey: DHLKeyInput!, $search: String) {
      agent(key: $agentKey) {
        composites(search: $search) {
          ...compositeSummaryFields
        }
      }
    }
  `,
  composite: gql`
    ${Fragments.trainingPhraseFields}
    ${Fragments.confirmationFields}
    ${Fragments.attributeFields}
    ${Fragments.dataQueryFields}
    ${Fragments.valueSuggestionFields}
    ${Fragments.variableFields}
    ${Fragments.serviceSlotFields}
    ${Fragments.genericTypeFields}
    ${Fragments.externalTypeFields}
    ${Fragments.attributeAssociationFields}
    ${Fragments.triggerConditionFields}
    ${Fragments.promptFields}
    ${Fragments.valueCheckFields}
    ${Fragments.originKeyFields}
    ${Fragments.stateUpdateFields}
    ${Fragments.frameMappingFields}
    ${Fragments.dialogActFields}
    ${Fragments.actionFields}
    ${Fragments.postFillActionFields}
    ${Fragments.channelDataFields}
    ${Fragments.augmentFields}
    query ($key: DHLKeyInput!) {
      result: composite(key: $key) {
        id
        name
        comment
        source
        origin_key {
          ...originKeyFields
        }
        struct_key {
          ...originKeyFields
        }
        inherited_frames {
          frame {
            id
            name
            type
          }
        }
        weak
        is_interface
        cui_disabled
        associate_type {
          id
          name
          type
        }
        sub_of_weak_type_id
        use_expression {
          id
          name
          type
        }
        attributes {
          ...attributeFields
        }
        nested_slot_customizations {
          ...attributeFields
        }
        head_slot {
          id
          name
          type
        }
        frame_expressions {
          ...trainingPhraseFields
        }
        negative_expressions {
          ...trainingPhraseFields
        }
        dont_care_expressions {
          ...trainingPhraseFields
        }
        data_queries {
          ...dataQueryFields
        }
        services {
          ...serviceSlotFields
          state
          inherited_from_composite_id
          inherited_from_composite_name
          is_overwrite
        }
        value_suggestions {
          ...valueSuggestionFields
        }
        generic_types {
          ...genericTypeFields
        }
        external_types {
          ...externalTypeFields
        }
        associations {
          ...attributeAssociationFields
        }
        confirmations {
          ...confirmationFields
        }
        triggers
        description
        value_checks {
          ...valueCheckFields
        }
        state_updates {
          ...stateUpdateFields
        }
        mappings {
          ...frameMappingFields
        }
        dialog_acts {
          ...dialogActFields
        }
        post_fill_actions {
          ...postFillActionFields
        }
        external_qualification
        source_type
        qualification
        enable_fallback
        fallback_info {
          ...augmentFields
        }
        is_global
        storage_enable
        storage_annotation {
          id
          origin_key {
            ...originKeyFields
          }
          struct_key {
            ...originKeyFields
          }
          owner_id
          unique_keys {
            id
            name
            type
          }
          enable_view
          view
        }
        imported_from_service
        return_info {
          type {
            ...variableFields
          }
          multi_valued
          value
          value_comment
          async
          actions {
            ...actionFields
          }
        }
        boolean_gate_prompts
        boolean_gate_expressions_yes {
          ...trainingPhraseFields
        }
        boolean_gate_expressions_no {
          ...trainingPhraseFields
        }
      }
    }
  `,
  compositeAvaibleParameters: gql`
    ${Fragments.attributeSummaryFields}
    ${Fragments.entitySummaryFields}
    ${Fragments.intentFields}
    ${Fragments.compositeFields}
    ${Fragments.dataQuerySummaryFields}
    ${Fragments.originKeyFields}
    query ($compositeKey: DHLKeyInput!, $agentKey: DHLKeyInput!) {
      composite(key: $compositeKey) {
        attributes {
          ...attributeSummaryFields
        }
        data_queries {
          ...dataQuerySummaryFields
        }
      }
      agent(key: $agentKey) {
        available_intents {
          ...intentFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_entities {
          ...entitySummaryFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_composites {
          ...compositeFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_services {
          id
          name
          source
          origin_key {
            ...originKeyFields
          }
          struct_key {
            ...originKeyFields
          }
          inherited_frames {
            frame {
              id
              name
              type
            }
          }
          is_interface
          external_qualification
          qualification
          attributes {
            ...attributeSummaryFields
          }
          data_queries {
            ...dataQuerySummaryFields
          }
          provider_type
        }
      }
    }
  `,
  availableComposites: gql`
    ${Fragments.attributeSummaryFields}
    ${Fragments.compositeFields}
    ${Fragments.originKeyFields}
    query ($key: DHLKeyInput!) {
      agent(key: $key) {
        available_composites {
          ...compositeFields
        }
      }
    }
  `,
  entities: gql`
    ${Fragments.originKeyFields}
    ${Fragments.entitySummaryFields}
    query ($agentKey: DHLKeyInput!, $search: String) {
      agent(key: $agentKey) {
        entities(search: $search) {
          ...entitySummaryFields
        }
      }
    }
  `,
  entity: gql`
    ${Fragments.variableFields}
    ${Fragments.originKeyFields}
    ${Fragments.entitySummaryFields}
    ${Fragments.promptFields}
    ${Fragments.trainingPhraseFields}
    ${Fragments.dataQueryFields}
    ${Fragments.valueSuggestionFields}
    query ($key: DHLKeyInput!, $search: String, $page: Int) {
      result: entity(key: $key) {
        ...entitySummaryFields
        dynamic
        dynamic_source
        dynamic_comment
        synonym
        parents {
          id
          name
        }
        normalizable
        children {
          id
          name
        }
        size(search: $search)
        content(search: $search, page: $page) {
          id
          origin_key {
            ...originKeyFields
          }
          struct_key {
            ...originKeyFields
          }
          owner_id
          label
          expressions
          append_to
        }
        description
        external_qualification
        source_type
        qualification
        dynamic
        recognizer
        dont_care_expressions {
          ...trainingPhraseFields
        }
        pronoun_expressions {
          ...trainingPhraseFields
        }
        data_queries {
          ...dataQueryFields
        }
        value_suggestions {
          ...valueSuggestionFields
        }
      }
    }
  `,
  entityAvailableParameters: gql`
    ${Fragments.trainingPhraseFields}
    ${Fragments.attributeSummaryFields}
    ${Fragments.dataQuerySummaryFields}
    ${Fragments.entitySummaryFields}
    ${Fragments.compositeFields}
    ${Fragments.dataQueryFields}
    ${Fragments.originKeyFields}
    query ($entityKey: DHLKeyInput!, $agentKey: DHLKeyInput!) {
      entity(key: $entityKey) {
        data_queries {
          ...dataQueryFields
        }
      }
      agent(key: $agentKey) {
        available_entities {
          ...entitySummaryFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_composites {
          ...compositeFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
      }
    }
  `,
  services: gql`
    ${Fragments.originKeyFields}
    ${Fragments.serviceSummaryFields}
    query ($agentKey: DHLKeyInput!, $search: String) {
      agent(key: $agentKey) {
        services(search: $search) {
          ...serviceSummaryFields
        }
      }
    }
  `,
  service: gql`
    ${Fragments.serviceSlotFields}
    ${Fragments.trainingPhraseFields}
    ${Fragments.triggerConditionFields}
    ${Fragments.confirmationFields}
    ${Fragments.valueCheckFields}
    ${Fragments.attributeFields}
    ${Fragments.dataQueryFields}
    ${Fragments.valueSuggestionFields}
    ${Fragments.variableFields}
    ${Fragments.promptFields}
    ${Fragments.externalTypeFields}
    ${Fragments.originKeyFields}
    ${Fragments.dialogActFields}
    ${Fragments.actionFields}
    ${Fragments.postFillActionFields}
    query ($key: DHLKeyInput!) {
      result: service(key: $key) {
        id
        name
        comment
        source
        origin_key {
          ...originKeyFields
        }
        struct_key {
          ...originKeyFields
        }
        inherited_frames {
          frame {
            id
            name
            type
          }
        }
        is_interface
        is_implementation
        external_qualification
        qualification
        attributes {
          ...attributeFields
        }
        nested_slot_customizations {
          ...attributeFields
        }
        data_queries {
          ...dataQueryFields
        }
        services {
          ...serviceSlotFields
          state
          inherited_from_composite_id
          inherited_from_composite_name
          is_overwrite
        }
        psql
        provider_type
        deploy_mode
        sql_config {
          url
          user
          password
          driver
        }
        webhook_config {
          url
          pairs {
            key
            value
          }
        }
        google_sheets_config {
          spreadsheet_id
          credential
        }
        native_config {
          provider_class_name
          configuration_meta
          dependency
        }
        external_types {
          ...externalTypeFields
        }
      }
    }
  `,
  serviceAvaibleParameters: gql`
    ${Fragments.attributeSummaryFields}
    ${Fragments.intentFields}
    ${Fragments.serviceFields}
    ${Fragments.entityFields}
    ${Fragments.compositeFields}
    ${Fragments.dataQuerySummaryFields}
    ${Fragments.originKeyFields}
    query ($agentKey: DHLKeyInput!) {
      agent(key: $agentKey) {
        available_intents {
          ...intentFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_entities {
          ...entityFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_composites {
          ...compositeFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
        available_services {
          ...serviceFields
          data_queries {
            ...dataQuerySummaryFields
          }
        }
      }
    }
  `,
  availableServices: gql`
    ${Fragments.attributeSummaryFields}
    ${Fragments.serviceFields}
    ${Fragments.originKeyFields}
    query ($key: DHLKeyInput!) {
      agent(key: $key) {
        available_services {
          ...serviceFields
        }
      }
    }
  `,
  attribute: gql`
    ${Fragments.variableFields}
    ${Fragments.valueSuggestionFields}
    ${Fragments.valueCheckFields}
    ${Fragments.dialogActFields}
    ${Fragments.actionFields}
    ${Fragments.postFillActionFields}
    ${Fragments.trainingPhraseFields}
    ${Fragments.attributeFields}
    ${Fragments.promptFields}
    ${Fragments.originKeyFields}
    ${Fragments.triggerConditionFields}
    ${Fragments.confirmationFields}
    query ($key: DHLKeyInput!) {
      result: attribute(key: $key) {
        ...attributeFields
      }
    }
  `,
  dataQuery: gql`
    ${Fragments.variableFields}
    ${Fragments.originKeyFields}
    ${Fragments.channelDataFields}
    ${Fragments.triggerConditionFields}
    ${Fragments.dataQueryFields}
    query ($key: DHLKeyInput!) {
      result: data_query(key: $key) {
        ...dataQueryFields
      }
    }
  `,
  stateUpdate: gql`
    ${Fragments.variableFields}
    ${Fragments.originKeyFields}
    ${Fragments.channelDataFields}
    ${Fragments.triggerConditionFields}
    ${Fragments.stateUpdateFields}
    query ($key: DHLKeyInput!) {
      result: state_update(key: $key) {
        ...stateUpdateFields
      }
    }
  `,
  connections: gql`
    ${Fragments.originKeyFields}
    ${Fragments.variableFields}
    query ($key: DHLKeyInput!) {
      agent(key: $key) {
        connections {
          id
          origin_key {
            ...originKeyFields
          }
          struct_key {
            ...originKeyFields
          }
          source
          agent_id
          mode
          name
          interface_service {
            ...variableFields
          }
          services {
            ...variableFields
          }
          implementation_service {
            ...variableFields
          }
          knowledge_agent_id
          configuration {
            key
            value
          }
          config_meta
          state
        }
      }
    }
  `,
  testCaseRuns: gql`
    ${Fragments.testCaseFields}
    query {
      result: test_case_runs {
        test_case_id
        test_case {
          ...testCaseFields
        }
        turns {
          query
          structure_input
          reply
          state
        }
        latest_run_time
        result
      }
    }
  `,
  selection: gql`
    query ($key: SelectionKey!, $path: [SelectionNode!]) {
      result: selection(key: $key, path: $path) {
        value
        value_type
        label
        is_leaf
        payload
      }
    }
  `,
  review: gql`
    ${Fragments.variableFields}
    ${Fragments.serviceSlotFields}
    ${Fragments.triggerConditionFields}
    ${Fragments.originKeyFields}
    ${Fragments.overwroteTrainingPhrase}
    ${Fragments.dataQueryFields}
    ${Fragments.actionFields}
    ${Fragments.channelDataFields}
    ${Fragments.trainingPhraseFields}
    ${Fragments.promptFields}
    ${Fragments.testCaseFields}
    ${Fragments.stateUpdateFields}
    ${Fragments.frameMappingFields}
    ${Fragments.valueCheckFields}
    ${Fragments.dialogActFields}
    ${Fragments.postFillActionFields}
    ${Fragments.augmentFields}
    fragment reviewTrainingPhrase on TrainingPhraseInfo {
      id
      training_phrase
      master_self {
        ...overwroteTrainingPhrase
      }
      state
    }

    fragment reviewPromptFields on PromptQuestion {
      ...promptFields
      master_self {
        prompt
      }
      state
    }

    fragment reviewConfirmation on ConfirmationInfo {
      id
      multi_valued
      condition_type
      trigger_conditions {
        ...triggerConditionFields
      }
      code_condition
      code_comment
      explicit_confirmation
      message_type
      prompts {
        ...reviewPromptFields
      }
      list_action {
        source
        source_comment
        header
        footer
        body
        template_id
        item_size
        delimiter_field
        delimiter_end
        single_prompts
        zero_prompts
      }
      affirmatives {
        ...reviewTrainingPhrase
      }
      negatives {
        ...reviewTrainingPhrase
      }
      master_self {
        multi_valued
        condition_type
        trigger_conditions {
          ...triggerConditionFields
        }
        code_condition
        code_comment
        explicit_confirmation
        message_type
        list_action {
          source
          source_comment
          header
          footer
          body
          template_id
          item_size
          delimiter_field
          delimiter_end
          single_prompts
          zero_prompts
        }
      }
      state
    }

    fragment reviewValueSuggestion on ValueSuggestion {
      id
      origin_key {
        ...originKeyFields
      }
      struct_key {
        ...originKeyFields
      }
      owner_id
      owner_type
      frame_id
      inherited_from_composite_id
      inherited_from_composite_name
      is_overwrite
      vr_source_type
      source_type
      source
      source_comment
      variable {
        ...variableFields
      }
      parameters {
        type
        variable {
          ...variableFields
        }
        constant
      }
      source_intent {
        intent {
          id
          name
          type
        }
        assignments {
          slot {
            id
            name
            type
          }
          code_expression
          code_comment
        }
      }
      channels {
        tag
        actions {
          id
          type
          list_action {
            source
            source_comment
            header
            footer
            body
            template_id
            item_size
            delimiter_field
            delimiter_end
            single_prompts
            zero_prompts
            other_channel_data {
              channel
              header
              body
              footer
            }
          }
        }
      }
      soft
      prompts {
        ...reviewPromptFields
      }
      zero_prompts {
        ...reviewPromptFields
      }
      explicit_confirmation
      single_affirmatives {
        ...reviewTrainingPhrase
      }
      single_negatives {
        ...reviewTrainingPhrase
      }
      master_self {
        vr_source_type
        source_type
        source
        source_comment
        variable {
          ...variableFields
        }
        parameters {
          type
          variable {
            ...variableFields
          }
          constant
        }
        source_intent {
          intent {
            id
            name
            type
          }
          assignments {
            slot {
              id
              name
              type
            }
            code_expression
            code_comment
          }
        }
        channels {
          tag
          actions {
            type
            list_action {
              source
              source_comment
              header
              footer
              body
              template_id
              item_size
              delimiter_field
              delimiter_end
              single_prompts
              zero_prompts
              other_channel_data {
                channel
                header
                body
                footer
              }
            }
          }
        }
        soft
      }
      state
    }

    fragment reviewAttribute on AttributeInfo {
      id
      name
      comment
      owner_id
      type {
        id
        name
        type
      }
      customization_path {
        id
        name
        type
      }
      implementation {
        id
        name
        type
      }
      triggers
      description
      multi_value
      allow_multi_value_prompt
      multi_value_min
      multi_value_max
      multi_value_questions {
        ...reviewPromptFields
      }
      multi_value_expressions_no {
        ...reviewTrainingPhrase
      }
      multi_value_min_exceptions {
        ...reviewPromptFields
      }
      multi_value_max_exceptions {
        ...reviewPromptFields
      }
      allow_dont_care
      dont_care_expressions {
        ...reviewTrainingPhrase
      }
      allow_companion
      attribute_companions {
        id
        name
        multi_value
        expressions {
          ...reviewTrainingPhrase
        }
      }
      allow_confirm
      confirmations {
        ...reviewConfirmation
      }
      allow_multi_valued_confirm
      multi_valued_confirmations {
        ...reviewConfirmation
      }
      prompt_questions {
        ...reviewPromptFields
      }
      prompt_expressions {
        ...reviewTrainingPhrase
      }
      enable_value_expression
      value_expressions {
        ...reviewTrainingPhrase
      }
      boolean_gated
      gated_type {
        id
        name
        type
      }
      boolean_gate_prompts
      boolean_gate_expressions_yes {
        ...trainingPhraseFields
        state
      }
      boolean_gate_expressions_no {
        ...trainingPhraseFields
        state
      }
      allow_slot_update
      slot_update_expressions {
        ...reviewTrainingPhrase
      }
      slot_append_expressions {
        ...reviewTrainingPhrase
      }
      slot_delete_expressions {
        ...reviewTrainingPhrase
      }
      negative_expressions {
        ...reviewTrainingPhrase
      }
      entailment_expressions {
        ...reviewTrainingPhrase
      }
      abort_expressions {
        ...reviewTrainingPhrase
        state
      }
      abort_negative_expressions {
        ...reviewTrainingPhrase
        state
      }
      abort_entailment_expressions {
        ...reviewTrainingPhrase
        state
      }
      fill_mode
      messaging_type
      fill_with_natural_language
      ask_strategy
      ask_condition_type
      ask_conditions {
        variable {
          id
          name
          type
          show_index
          index
        }
        parameters {
          type
          variable {
            ...variableFields
          }
          constant
        }
        conditions {
          operation_at
          operation
          value
        }
      }
      ask_code_condition
      condition_comment
      inform_prompts {
        ...reviewPromptFields
      }
      allow_initialization
      initializations {
        id
        owner_id
        frame_id
        target {
          ...variableFields
        }
        association
        association_comment
        state
        master_self {
          target {
            ...variableFields
          }
          association
        }
      }
      enable_filtering
      filterings {
        id
        owner_id
        frame_id
        source_slot {
          ...variableFields
        }
        filtering_expression
        inform_prompts {
          ...reviewPromptFields
        }
        state
        master_self {
          source_slot {
            ...variableFields
          }
          filtering_expression
        }
      }
      auxiliary
      allow_value_suggestion
      value_suggestions {
        ...reviewValueSuggestion
      }
      allow_value_check
      value_checks {
        ...reviewValueCheck
      }
      dialog_acts {
        ...reviewDialogAct
      }
      post_fill_actions {
        ...reviewPostFillAction
      }
      allow_prompt
      allow_expression
      storage_annotation {
        id
        state
        data_type
        for_url
        not_null
        default_value
        input_type
        dropdown
        hide_in_list_view
        read_only
        sortable
        relationship
        master_self {
          data_type
          not_null
          default_value
          input_type
          dropdown
          hide_in_list_view
          read_only
          sortable
          relationship
        }
      }
      master_self {
        name
        implementation {
          id
          name
          type
        }
        comment
        triggers
        description
        multi_value
        multi_value_min
        multi_value_max
        allow_dont_care
        allow_confirm
        allow_multi_value_prompt
        allow_multi_valued_confirm
        allow_prompt
        allow_expression
        allow_value_suggestion
        allow_value_check
        allow_slot_update
        allow_companion
        enable_value_expression
        fill_mode
        messaging_type
        fill_with_natural_language
        ask_strategy
        ask_condition_type
        boolean_gate_prompts
        ask_conditions {
          variable {
            id
            name
            type
            show_index
            index
          }
          parameters {
            type
            variable {
              ...variableFields
            }
            constant
          }
          conditions {
            operation_at
            operation
            value
          }
        }
        ask_code_condition
        condition_comment
        allow_initialization
        enable_filtering
        auxiliary
        boolean_gated
        gated_type {
          id
          name
          type
        }
      }
      state
    }

    fragment reviewDataQuery on DataQueryInfo {
      ...dataQueryFields
      master_self {
        name
        comment
        parameters {
          name
          type {
            id
            name
            type
          }
          multi_value
          nullable
          comment
        }
        query_type
        schedule
        kotlin
        database_config {
          function_meta {
            key
            value
          }
          query
          result_format
          cron
        }
        restful_config {
          path
          post_body
          headers {
            key
            value
          }
        }
        function_config {
          parameters {
            name
            type {
              id
              type
              name
            }
            multi_value
          }
          body
        }
        prompt_implemented
        prompt_config {
          prompt
          model_id
          inference_config {
            temperature
            topk
            max_input_length
            max_think_length
            max_output_length
          }
          context_collections {
            remote
            source
            file_type
            knowledge_label
            related_tags {
              key
              value
            }
          }
          contexts
          examples
          example_collections {
            source
            related_tags {
              key
              value
            }
          }
        }
        body_comment
        type {
          id
          type
          name
        }
        error_messages
        multi_value
        disable_return_null
        allow_trigger
      }
      state
    }

    fragment genericTypeFields on GenericType {
      id
      name
      state
    }

    fragment externalTypeFields on ExternalType {
      id
      name
      state
    }

    fragment associationFields on Association {
      variable {
        id
        type
        name
      }
      variable_type
      default_values {
        id
        type
        name
      }
      state
    }

    fragment reviewValueCheck on ValueCheck {
      ...valueCheckFields
      master_self {
        source
        source_comment
        variable {
          id
          name
          type
        }
        parameters {
          type
          variable {
            ...variableFields
          }
          constant
        }
        recovering
        recovering_actions {
          id
          type
          clear_slot_action {
            slot {
              id
              name
              type
            }
          }
          recheck_action {
            slot {
              id
              name
              type
            }
          }
        }
      }
      state
    }

    fragment reviewStateUpdate on StateUpdateInfo {
      ...stateUpdateFields
      master_self {
        name
        trigger_method
        event {
          ...variableFields
        }
        event_states {
          target_slot {
            ...variableFields
          }
          code_expression
        }
        condition_type
        conditions {
          ...triggerConditionFields
        }
        condition_code
        code_comment
        state_config {
          slot {
            ...variableFields
          }
          state
        }
        trigger_timing {
          ...variableFields
        }
        channels {
          ...channelDataFields
        }
      }
      state
    }

    fragment reviewFrameMapping on FrameMapping {
      ...frameMappingFields
      master_self {
        target_frame {
          ...variableFields
        }
        contents {
          target_slot {
            ...variableFields
          }
          mapping_slot {
            ...variableFields
          }
          conversion_mode
        }
      }
      state
    }

    fragment reviewDialogAct on DialogAct {
      ...dialogActFields
      master_self {
        intent {
          id
          name
          type
        }
      }
      state
    }

    fragment reviewPostFillAction on PostFillAction {
      ...postFillActionFields
      master_self {
        condition
        condition_comment
        actions {
          ...actionFields
        }
      }
      state
    }

    query (
      $key: DHLKeyInput!
      $missionInput: SearchMissionInput
      $strategy: CompareStrategy
    ) {
      result: agent(
        key: $key
        missionInput: $missionInput
        strategy: $strategy
      ) {
        id
        name
        description
        icon_url
        privacy
        deploy_mode
        region
        pr_approval_required
        imported_agents {
          origin_key {
            ...originKeyFields
          }
          mode
          lang
          name
          org_name
          description
        }
        time_zone
        read_me
        master_self {
          name
          description
          icon_url
          privacy
          deploy_mode
          region
          pr_approval_required
          imported_agents {
            origin_key {
              ...originKeyFields
            }
            mode
            lang
            name
            org_name
            description
          }
          time_zone
          read_me
        }
        intents {
          id
          name
          comment
          source
          external_qualification
          qualification
          triggered_by_du
          description
          triggers
          dialog_act
          frame_expressions {
            ...reviewTrainingPhrase
            state
          }
          negative_expressions {
            ...reviewTrainingPhrase
            state
          }
          entailment_expressions {
            ...reviewTrainingPhrase
            state
          }
          abort_expressions {
            ...reviewTrainingPhrase
            state
          }
          abort_negative_expressions {
            ...reviewTrainingPhrase
            state
          }
          abort_entailment_expressions {
            ...reviewTrainingPhrase
            state
          }
          attributes {
            ...reviewAttribute
          }
          nested_slot_customizations {
            ...reviewAttribute
          }
          slot_position {
            page_id
          }
          response_position {
            page_id
          }
          value_suggestions {
            ...reviewValueSuggestion
          }
          data_queries {
            ...reviewDataQuery
          }
          services {
            ...serviceSlotFields
          }
          branching
          responses {
            id
            name
            owner_id
            condition_type
            trigger_conditions {
              ...triggerConditionFields
            }
            code_condition
            code_comment
            channels {
              ...channelDataFields
            }
            early_termination
            is_else_branch
            master_self {
              name
              condition_type
              trigger_conditions {
                ...triggerConditionFields
              }
              code_condition
              code_comment
              channels {
                ...channelDataFields
              }
              early_termination
            }
            state
          }
          enable_fallback
          fallback_info {
            ...augmentFields
          }
          soft
          soft_response {
            ...augmentFields
          }
          inherited_frames {
            frame {
              id
              name
              type
            }
            state
          }
          generic_types {
            ...genericTypeFields
          }
          external_types {
            ...externalTypeFields
          }
          associations {
            ...associationFields
          }
          value_checks {
            ...reviewValueCheck
          }
          confirmations {
            ...reviewConfirmation
          }
          state_updates {
            ...reviewStateUpdate
          }
          mappings {
            ...reviewFrameMapping
          }
          dialog_acts {
            ...dialogActFields
          }
          post_fill_actions {
            ...postFillActionFields
          }
          cron_data {
            data_query_id
            schedule
          }
          return_info {
            type {
              ...variableFields
            }
            multi_valued
            value
            value_comment
            async
            actions {
              ...actionFields
            }
          }
          boolean_gate_prompts
          master_self {
            name
            comment
            external_qualification
            qualification
            triggered_by_du
            dialog_act
            slot_position {
              page_id
            }
            services {
              ...serviceSlotFields
            }
            response_position {
              page_id
            }
            branching
            description
            triggers
            inherited_frames {
              frame {
                id
                name
                type
              }
              state
            }
            generic_types {
              ...genericTypeFields
            }
            external_types {
              ...externalTypeFields
            }
            associations {
              ...associationFields
            }
            cron_data {
              data_query_id
              schedule
            }
            return_info {
              type {
                ...variableFields
              }
              multi_valued
              value
              value_comment
              async
              actions {
                ...actionFields
              }
            }
            boolean_gate_prompts
            enable_fallback
            fallback_info {
              ...augmentFields
            }
            soft
            soft_response {
              ...augmentFields
            }
          }
          state
        }
        composites {
          id
          agent_id
          name
          comment
          source
          weak
          is_interface
          cui_disabled
          associate_type {
            id
            name
            type
          }
          use_expression {
            id
            name
            type
          }
          slot_position {
            page_id
          }
          description
          triggers
          frame_expressions {
            ...reviewTrainingPhrase
            state
          }
          negative_expressions {
            ...reviewTrainingPhrase
            state
          }
          dont_care_expressions {
            ...reviewTrainingPhrase
            state
          }
          attributes {
            ...reviewAttribute
          }
          nested_slot_customizations {
            ...reviewAttribute
          }
          head_slot {
            id
            name
            type
          }
          value_suggestions {
            ...reviewValueSuggestion
          }
          data_queries {
            ...reviewDataQuery
          }
          services {
            ...serviceSlotFields
          }
          inherited_frames {
            frame {
              id
              name
              type
            }
            state
          }
          generic_types {
            ...genericTypeFields
          }
          external_types {
            ...externalTypeFields
          }
          associations {
            ...associationFields
          }
          confirmations {
            ...reviewConfirmation
          }
          value_checks {
            ...reviewValueCheck
          }
          state_updates {
            ...reviewStateUpdate
          }
          mappings {
            ...reviewFrameMapping
          }
          dialog_acts {
            ...dialogActFields
          }
          post_fill_actions {
            ...reviewPostFillAction
          }
          external_qualification
          source_type
          qualification
          enable_fallback
          fallback_info {
            ...augmentFields
          }
          is_global
          storage_enable
          storage_annotation {
            state
            id
            unique_keys {
              id
              name
              type
            }
            enable_view
            view
            master_self {
              unique_keys {
                id
                name
                type
              }
              enable_view
              view
            }
          }
          return_info {
            type {
              ...variableFields
            }
            multi_valued
            value
            value_comment
            async
            actions {
              ...actionFields
            }
          }
          boolean_gate_prompts
          master_self {
            name
            comment
            weak
            is_interface
            cui_disabled
            associate_type {
              id
              name
              type
            }
            use_expression {
              id
              name
              type
            }
            slot_position {
              page_id
            }
            head_slot {
              id
              name
              type
            }
            services {
              ...serviceSlotFields
            }
            description
            triggers
            inherited_frames {
              frame {
                id
                name
                type
              }
              state
            }
            generic_types {
              ...genericTypeFields
            }
            external_types {
              ...externalTypeFields
            }
            associations {
              ...associationFields
            }
            external_qualification
            source_type
            qualification
            enable_fallback
            fallback_info {
              ...augmentFields
            }
            is_global
            storage_enable
            return_info {
              type {
                ...variableFields
              }
              multi_valued
              value
              value_comment
              async
              actions {
                ...actionFields
              }
            }
            boolean_gate_prompts
          }
          state
        }
        entities {
          id
          name
          comment
          source
          abstract
          description
          cui_disabled
          dynamic
          dynamic_source
          dynamic_comment
          synonym
          parents {
            id
            name
          }
          normalizable
          content {
            id
            origin_key {
              ...originKeyFields
            }
            owner_id
            label
            expressions
            append_to
            master_self {
              label
              expressions
            }
            state
          }
          external_qualification
          source_type
          qualification
          recognizer
          dont_care_expressions {
            ...trainingPhraseFields
            state
          }
          pronoun_expressions {
            ...trainingPhraseFields
            state
          }
          data_queries {
            ...reviewDataQuery
            state
          }
          value_suggestions {
            ...reviewValueSuggestion
          }
          master_self {
            name
            comment
            description
            cui_disabled
            abstract
            dynamic
            dynamic_source
            dynamic_comment
            synonym
            parents {
              id
              name
            }
            normalizable
            external_qualification
            source_type
            qualification
            recognizer
          }
          state
        }
        services {
          id
          agent_id
          name
          comment
          source
          is_interface
          is_implementation
          slot_position {
            page_id
          }
          attributes {
            ...reviewAttribute
          }
          nested_slot_customizations {
            ...reviewAttribute
          }
          data_queries {
            ...reviewDataQuery
          }
          services {
            ...serviceSlotFields
          }
          inherited_frames {
            frame {
              id
              name
              type
            }
            state
          }
          psql
          provider_type
          sql_config {
            url
            user
            password
            driver
          }
          webhook_config {
            url
            pairs {
              key
              value
            }
          }
          google_sheets_config {
            spreadsheet_id
            credential
          }
          native_config {
            provider_class_name
            configuration_meta
            dependency
          }
          external_types {
            ...externalTypeFields
          }
          external_qualification
          qualification
          master_self {
            name
            comment
            is_interface
            slot_position {
              page_id
            }
            inherited_frames {
              frame {
                id
                name
                type
              }
              state
            }
            external_qualification
            qualification
            services {
              ...serviceSlotFields
            }
            psql
            provider_type
            sql_config {
              url
              user
              password
              driver
            }
            webhook_config {
              url
              pairs {
                key
                value
              }
            }
            google_sheets_config {
              spreadsheet_id
              credential
            }
            native_config {
              provider_class_name
              configuration_meta
              dependency
            }
            external_types {
              ...externalTypeFields
            }
          }
          state
        }
        connections {
          id
          origin_key {
            ...originKeyFields
          }
          name
          interface_service {
            ...variableFields
          }
          services {
            ...variableFields
          }
          implementation_service {
            ...variableFields
          }
          knowledge_agent_id
          configuration {
            key
            value
          }
          master_self {
            name
            interface_service {
              ...variableFields
            }
            services {
              ...variableFields
            }
            implementation_service {
              ...variableFields
            }
            knowledge_agent_id
            configuration {
              key
              value
            }
          }
          state
        }
        test_cases {
          ...testCaseFields
          state
          master_self {
            name
            turns {
              query
              structure_input
              reply
              state
            }
          }
        }
      }
    }
  `,
  integrations: gql`
    query ($agentID: String!) {
      result: AgentIntegrations(agentID: $agentID) {
        agent_id
        id
        integration_type
        label
        default_language
        facebook_setting {
          callback_url
          verify_token
          page_access_token
        }
        rocket_setting {
          callback_url
          url
        }
        twilio_setting {
          account_sid
          auth_token
        }
        lark_setting {
          app_id
          app_secret
          verification_token
          encrypt_key
        }
        wechat_public_account_setting {
          app_id
          token
          app_secret
          payment
          mchid
          api_key
          certificate
        }
        rbm_setting {
          client_token
          credential
        }
        teleunion_rcs_setting {
          app_id
          app_key
          server_root
          chatbot_address
          token
        }
        whatsapp_business_setting {
          verify_token
          access_token
          phone_number_id
        }
        google_business_message_setting {
          client_token
          credential
        }
      }
    }
  `,
};
